import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '../../../../common/html/icon'
import { SelectCustom } from '../../../../common/selectCustom'
import { getUnique } from '../../../../helpers/common'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const CreditRiskThreshold = ({ isDefaultProfile, rowId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectDataTable(rowId))

  const listCondition = dataRow?.conditions || [{}]

  const onChooseItem = (value, conditionIndex) => {
    const arrCondition = dataRow?.conditions || []
    const newArr = [...arrCondition]
    newArr[conditionIndex] = {
      ...dataRow?.conditions?.[conditionIndex],
      conditionValueId: value.conditionId,
    }

    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          conditions: newArr,
        },
      }),
    )
  }

  const handleAdd = () => {
    if (!!isDefaultProfile) return
    const arrCondition = dataRow?.conditions || []
    const newArr = [...arrCondition]
    newArr.push({
      conditionId: dataRow.conditionSettings[0].conditionId,
    })

    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          conditions: newArr,
        },
      }),
    )
  }

  const handleRemove = (index) => {
    if (!!isDefaultProfile) return
    const arrCondition = dataRow?.conditions || []
    const newArr = [...arrCondition]
    newArr.splice(index, 1)

    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          conditions: newArr,
        },
      }),
    )
  }

  if (!dataRow.conditionSettings?.[0]?.allowMultiple) return <></>

  return (
    <div className="flexColumn gap1">
      {listCondition.map((item, index) => {
        return (
          <ItemThreshold
            key={index}
            index={index}
            dataRow={dataRow}
            onChooseItem={onChooseItem}
            isDefaultProfile={
              isDefaultProfile || !dataRow.sendNotification || dataRow.disabled
            }
            handleRemove={handleRemove}
            handleAdd={handleAdd}
            conditions={listCondition}
          />
        )
      })}
    </div>
  )
}

export const ItemThreshold = ({
  index,
  dataRow,
  onChooseItem,
  isDefaultProfile,
  handleRemove,
  handleAdd,
  conditions,
}) => {
  const activeData = dataRow?.conditions?.[index]?.conditionValueId
  const options =
    dataRow.conditionSettings.find(
      (key) => key?.conditionId === dataRow?.conditions?.[index]?.conditionId,
    )?.conditionValues || []

  const disabled = !options.length

  useEffect(() => {
    if (
      !activeData ||
      options.find((item) => item.conditionId === activeData)?.disabled ||
      !options.find((item) => item.conditionId === activeData)
    ) {
      onChooseItem(
        {
          conditionId: options.find((item) => !item.disabled)?.conditionId,
        },
        index,
      )
    }
  }, [dataRow?.conditions?.[index]?.conditionId])

  return (
    <div
      key={getUnique()}
      className="dFlex gap2 alignItemsCenter justifyContentBetween"
    >
      <SelectCustom
        activeItem={{
          value: activeData,
        }}
        data={options.map((item) => ({
          ...item,
          label: item.conditionName,
          value: item.conditionId,
          disabled: item.disabled,
        }))}
        chooseItem={(item) => onChooseItem(item, index)}
        disabled={disabled || !!isDefaultProfile}
        iconWhenHiddenDropList={disabled ? '' : undefined}
        isI18n
        zIndex={14}
        className="w100"
        style={{
          opacity: !disabled ? 1 : 0.54,
          backgroundColor: '#D5D5D5',
          color: !!isDefaultProfile ? '#9C9C9C' : '#3A414B',
          cursor: disabled || !!isDefaultProfile ? 'not-allowed' : 'pointer',
          padding: '0px 27px 0px 12px',
          minWidth: 80,
        }}
        styleDropdown={{ whiteSpace: 'nowrap' }}
      />

      <div className="dFlex gap1 alignItemsCenter">
        <Icon
          className="icon-checkbox-minus-fill"
          style={{
            fontSize: 12,
            color: '#2C73E8',
            visibility: !!isDefaultProfile
              ? 'hidden'
              : conditions.length > 1
              ? 'visible'
              : 'hidden',
          }}
          onClick={() => handleRemove(index)}
        />
        <Icon
          className="icon-plus-square-fill dBlock"
          style={{
            fontSize: 12,
            color: disabled ? '#D5D5D5' : '#2C73E8',
            cursor: disabled ? 'default' : 'pointer',
            visibility: !!isDefaultProfile
              ? 'hidden'
              : index === conditions.length - 1
              ? 'visible'
              : 'hidden',
          }}
          onClick={disabled ? undefined : handleAdd}
        />
      </div>
    </div>
  )
}
